import { Inject, Component } from "@angular/core";
import { OktaAuth } from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";

@Component({
    selector: "app-login",
    template: ``,
    standalone: false,
})
export class LoginComponent {
    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {
        this.oktaAuth.signInWithRedirect();
    }
}
